import { Pipe, PipeTransform } from '@angular/core';

import { Device } from '../devices/device.model';

@Pipe({
  name: 'poorConnectionDevices'
})
export class PoorConnectionDevicesPipe implements PipeTransform {

  transform(devices: Device[]): Device[] {
    return devices.filter((device) => {
      return device.online && device.rssi_value && device.rssi_value <= 2;
    });
  }

}
